import { FC } from 'react';
import { Stack } from '@mui/material';
import { InputCheck, InputText, InputTextArea } from '@farmshare/ui-components';
import { Trim } from '../../types';

interface TrimPercentageQuestionFormProps {
  trims?: Trim[];
  /** The capability set ID used to group uploaded images in S3. */
  capabilityId: string;
}

/**
 * Form for creating/editing Trim Percentage questions.
 * The available trims are managed via drag-and-drop on the question card
 * itself (same pattern as Trim Ranking, Free Selection, Extras Selection).
 * @param root0
 * @param root0.trims
 * @param root0.capabilityId
 */
export const TrimPercentageQuestionForm: FC<
  TrimPercentageQuestionFormProps
> = ({ trims = [], capabilityId }) => {
  // trims + capabilityId kept for API compatibility; not rendered here
  // since availableTrimIds is populated via drag-and-drop.
  void trims;
  void capabilityId;

  return (
    <Stack spacing={3}>
      <InputText label="Question Title" nameOverride="title" required />
      <InputTextArea
        label="Description"
        nameOverride="description"
        rows={2}
        hint="Optional description to help customers understand their options"
      />

      <InputCheck
        label="Required"
        nameOverride="required"
        hint="Whether customers must answer this question"
      />
    </Stack>
  );
};
